module.exports = __webpack_public_path__ + "img/baseball.8b05a1d1.svg";